import React from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';
import { Menu, Segment } from "semantic-ui-react";

import './index.scss'
import { useSelector } from 'react-redux';

const CustomerTab = () => {
    const { account_id } = useParams();

    const routeRoot = `/account/${account_id}/customer`;
    const isDyl = useSelector(state => state.auth.dyl_employee);

    return (
        <div className='CustomerTab'>
            <Segment className='CustomerTab__Segment'>
                <Menu className='CustomerTab__Menu' color='primary' pointing secondary>
                    <Menu.Item
                        name='Pipelines'
                        as={NavLink}
                        to={`${routeRoot}/pipelines`}
                    />
                    {isDyl ? (
                        <Menu.Item
                            name='Orders/Invoices'
                            content={<span>Orders/Invoices</span>}
                            as={NavLink}
                            to={`${routeRoot}/orders_invoices`}
                        />
                    ) : (
                        <>
                            <Menu.Item
                                name='Orders'
                                content={<span>Orders</span>}
                                as={NavLink}
                                to={`${routeRoot}/orders`}
                            />
                            <Menu.Item
                                name='Invoices'
                                content={<span>Invoices</span>}
                                as={NavLink}
                                to={`${routeRoot}/invoices`}
                            />
                        </>
                    )}
                    
                    <Menu.Item
                        name='Subscription Products'
                        as={NavLink}
                        to={`${routeRoot}/subscription_products`}
                    />
                </Menu>
                <Outlet />
            </Segment>
        </div>
    )
}

export default CustomerTab;
